import { makeStyles } from '@fluentui/react-components';

/**
 * Shared styling used for 'View Selector' (When nested in toolbar) and workspace refresh button.
 */
export const useGridToolbarItemStyles = makeStyles({
  switchView: {
    display: 'flex',
    order: 2,
    borderLeft: '1px solid #e0e0e0',
    alignItems: 'center',
    height: '42px',
    paddingRight: '10px',
  },
  switchViewLink: {
    color: 'var(--grey120)',
    fontSize: '16px',
    display: 'flex',
    cursor: 'pointer',
    marginLeft: '0.4rem',
    '&:hover,&:focus': {
      color: 'var(--appLink)',
      textDecoration: 'none',
    },
  },
});
